/**
 * MusicPlayer 音频图纯工具（抽离自 MusicPlayer.js）
 * 不含 React / refs，仅纯函数。
 */

export function disconnectNodeSafely(node) {
  if (!node) return;
  try {
    node.disconnect();
  } catch (_) {}
}

const EQUALIZER_PRESETS = {
  normal: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  pop: [0, 0, 2, 4, 3, 0, -1, -1, 0, 1],
  rock: [4, 3, -3, -4, -2, 2, 4, 4, 3, 3],
  classical: [3, 2, 0, -2, -3, -3, -2, 0, 2, 3],
  jazz: [2, 1, 0, 1, 2, 1, 0, 1, 2, 2],
  bass: [6, 5, 4, 2, 0, -2, -3, -4, -4, -4],
  treble: [-4, -4, -3, -2, 0, 2, 4, 5, 6, 6],
  vocal: [-2, -1, 0, 1, 2, 3, 2, 1, 0, -1]
};

export function getEqualizerGains(preset) {
  return EQUALIZER_PRESETS[preset] || EQUALIZER_PRESETS.normal;
}

export function isIOSDevice() {
  const ua = typeof navigator !== 'undefined' ? (navigator.userAgent || '') : '';
  const isIOS = /iPad|iPhone|iPod/.test(ua);
  const isIPadOS = ua.includes('Mac') && navigator.maxTouchPoints > 1;
  return isIOS || isIPadOS;
}
